/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PurchaseCostCoverageItemData } from './PurchaseCostCoverageItemData';
import {
    PurchaseCostCoverageItemDataFromJSON,
    PurchaseCostCoverageItemDataFromJSONTyped,
    PurchaseCostCoverageItemDataToJSON,
    PurchaseCostCoverageItemDataToJSONTyped,
} from './PurchaseCostCoverageItemData';

/**
 * 
 * @export
 * @interface PurchaseCostCoverageOrderData
 */
export interface PurchaseCostCoverageOrderData {
    /**
     * 
     * @type {string}
     * @memberof PurchaseCostCoverageOrderData
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseCostCoverageOrderData
     */
    orderNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseCostCoverageOrderData
     */
    orderedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseCostCoverageOrderData
     */
    missingLineCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseCostCoverageOrderData
     */
    unknownOriginLineCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseCostCoverageOrderData
     */
    totalItems?: number;
    /**
     * 
     * @type {Array<PurchaseCostCoverageItemData>}
     * @memberof PurchaseCostCoverageOrderData
     */
    items?: Array<PurchaseCostCoverageItemData>;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseCostCoverageOrderData
     */
    itemsTruncated?: boolean;
}

/**
 * Check if a given object implements the PurchaseCostCoverageOrderData interface.
 */
export function instanceOfPurchaseCostCoverageOrderData(value: object): value is PurchaseCostCoverageOrderData {
    return true;
}

export function PurchaseCostCoverageOrderDataFromJSON(json: any): PurchaseCostCoverageOrderData {
    return PurchaseCostCoverageOrderDataFromJSONTyped(json, false);
}

export function PurchaseCostCoverageOrderDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseCostCoverageOrderData {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderNumber': json['orderNumber'] === undefined ? undefined : json['orderNumber'] === null ? null : json['orderNumber'],
        'orderedAt': json['orderedAt'] == null ? undefined : json['orderedAt'],
        'missingLineCount': json['missingLineCount'] == null ? undefined : json['missingLineCount'],
        'unknownOriginLineCount': json['unknownOriginLineCount'] == null ? undefined : json['unknownOriginLineCount'],
        'totalItems': json['totalItems'] == null ? undefined : json['totalItems'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(PurchaseCostCoverageItemDataFromJSON)),
        'itemsTruncated': json['itemsTruncated'] == null ? undefined : json['itemsTruncated'],
    };
}

export function PurchaseCostCoverageOrderDataToJSON(json: any): PurchaseCostCoverageOrderData {
    return PurchaseCostCoverageOrderDataToJSONTyped(json, false);
}

export function PurchaseCostCoverageOrderDataToJSONTyped(value?: PurchaseCostCoverageOrderData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderNumber': value['orderNumber'],
        'orderedAt': value['orderedAt'],
        'missingLineCount': value['missingLineCount'],
        'unknownOriginLineCount': value['unknownOriginLineCount'],
        'totalItems': value['totalItems'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(PurchaseCostCoverageItemDataToJSON)),
        'itemsTruncated': value['itemsTruncated'],
    };
}

